import { render } from "./online.vue?vue&type=template&id=2357903c&scoped=true"
import script from "./online.vue?vue&type=script&lang=js"
export * from "./online.vue?vue&type=script&lang=js"

import "./online.vue?vue&type=style&index=0&id=2357903c&scoped=true&lang=stylus&rel=stylesheet%2Fstylus"

import exportComponent from "/opt/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2357903c"]])

export default __exports__